import { ROUND_TO_INT } from "./index76.js";
import { BoundKnapSack } from "./index125.js";
function FloatBoundKnapSackProps(items, target, roundBy = ROUND_TO_INT) {
  target = Math.round(target * roundBy);
  items = items.slice();
  for (let i = 0; i < items.length; i++) {
    items[i] = {
      ...items[i],
      value: Math.round(items[i].value * roundBy)
    };
  }
  const result = BoundKnapSack({ values: items, target });
  result.total /= roundBy;
  for (const item of result.values) {
    item.value /= roundBy;
  }
  return result;
}
export {
  FloatBoundKnapSackProps
};
//# sourceMappingURL=index126.js.map
